import { create } from "zustand";

interface MessageInputState {
  messageInputs: Record<string, string>;
  setMessageInput: (conversationId: string, messageInput: string) => void;
  supervisorMessageInput: string;
  setSupervisorMessageInput: (supervisorMessageInput: string) => void;
}

export const useMessageInputStore = create<MessageInputState>((set) => ({
  messageInputs: {},
  setMessageInput: (conversationId, messageInput) =>
    set((state) => ({
      messageInputs: {
        ...state.messageInputs,
        [conversationId]: messageInput,
      },
    })),
  supervisorMessageInput: "",
  setSupervisorMessageInput: (messageInput: string) =>
    set(() => ({
      supervisorMessageInput: messageInput,
    })),
}));
